import { Box, Text } from 'native-base';
import React from 'react';

import Carousel from 'app/components/Carousel';
import { useI18n } from 'app/providers/I18nProvider';

export type TicketsCarouselPaginationProps = {
  index: number;
  cardHeight: number;
  total: number;
};

export default function TicketsCarouselPagination({
  index,
  cardHeight,
  total,
}: TicketsCarouselPaginationProps) {
  const { t } = useI18n();

  return (
    <Box mx="auto" opacity={cardHeight ? 1 : 0} w="full">
      <Text bold color="white" textAlign="center">
        {index + 1} {t('gen_of')} {total}
      </Text>
      <Carousel.Pagination bottom="0" index={index} position="relative" total={total} />
    </Box>
  );
}
